module.exports = __webpack_public_path__ + "img/About.4790ad1e.png";